module.exports = "/assets/data/4c8bbcebbbaedec38c567193dbf6efd9-NW11.data.json";